/*Import Estilo*/
import '../institucional.scss';
import '../../../css/global.css';
import '../../../css/normalize.css';

/*Import Componentes*/
import Cabecalho from '../../../components/Cabecalho';
import Rodape from '../../../components/Rodape';
import CookieAceite from '../../../components/CookieAceite';

/*Import SEO*/
import { SEOHelmet } from '../../../hooks/useSEO';

export default function PoliticasPrivacidade() {
    const seoData = {
        title: 'Políticas de Privacidade - Fracaro Store',
        description: 'Saiba como a Fracaro Store coleta, armazena e protege seus dados pessoais conforme a LGPD.',
        keywords: 'privacidade, dados pessoais, LGPD, fracaro store, proteção de dados',
        url: window.location.href,
    };

    return (
        <section className='container-principal-institucional'>
            <SEOHelmet {...seoData} />
            <Cabecalho />
            <CookieAceite />
            <main>
                <div className='hero-institucional'>
                    <div className='hero-overlay'>
                        <h1>Políticas de Privacidade</h1>
                        <p>Seus dados seguros e protegidos</p>
                    </div>
                </div>

                <div className='conteudo-institucional'>
                    <h2>1. Informações que Coletamos</h2>
                    <p>
                        A Fracaro Store coleta apenas as informações necessárias para oferecer a melhor 
                        experiência de compra. Os dados coletados incluem:
                    </p>
                    <ul>
                        <li><strong>Dados pessoais:</strong> Nome, CPF, email, telefone e data de nascimento</li>
                        <li><strong>Dados de endereço:</strong> CEP, logradouro, número, complemento, bairro, cidade e estado</li>
                        <li><strong>Dados de navegação:</strong> Cookies, páginas visitadas e preferências</li>
                        <li><strong>Dados de pagamento:</strong> Processados de forma segura pelo gateway de pagamento (não armazenamos dados de cartão)</li>
                    </ul>

                    <h2>2. Como Utilizamos seus Dados</h2>
                    <p>Seus dados são utilizados exclusivamente para:</p>
                    <ul>
                        <li>Processar e entregar seus pedidos</li>
                        <li>Enviar atualizações sobre o status do pedido</li>
                        <li>Comunicar promoções e novidades (com seu consentimento)</li>
                        <li>Melhorar a experiência de navegação no site</li>
                        <li>Cumprir obrigações legais e fiscais</li>
                    </ul>

                    <div className='destaque-box'>
                        <p>Nunca vendemos, compartilhamos ou alugamos seus dados pessoais a terceiros para fins publicitários.</p>
                    </div>

                    <h2>3. Proteção dos Dados</h2>
                    <p>
                        Adotamos medidas técnicas e organizacionais para proteger seus dados, incluindo:
                    </p>
                    <ul>
                        <li>Criptografia SSL/TLS em todas as páginas</li>
                        <li>Senhas armazenadas com hash bcrypt</li>
                        <li>Autenticação via tokens JWT seguros em cookies HttpOnly</li>
                        <li>Proteção contra ataques XSS, CSRF e injeção SQL</li>
                        <li>Acesso restrito aos dados apenas por pessoal autorizado</li>
                    </ul>

                    <h2>4. Cookies</h2>
                    <p>
                        Utilizamos cookies para melhorar sua experiência de navegação. Ao continuar 
                        navegando em nosso site, você concorda com o uso de cookies conforme esta política.
                    </p>
                    <h3>Tipos de cookies utilizados:</h3>
                    <ul>
                        <li><strong>Essenciais:</strong> Necessários para o funcionamento do site (autenticação, carrinho)</li>
                        <li><strong>Análise:</strong> Google Analytics para entender o comportamento dos visitantes</li>
                        <li><strong>Preferências:</strong> Lembrar suas escolhas e personalizar a experiência</li>
                    </ul>

                    <h2>5. Seus Direitos (LGPD)</h2>
                    <p>
                        Conforme a <strong>Lei Geral de Proteção de Dados (Lei 13.709/2018)</strong>, você tem os seguintes direitos:
                    </p>
                    <ul>
                        <li>Confirmar a existência de tratamento de dados</li>
                        <li>Acessar seus dados pessoais</li>
                        <li>Corrigir dados incompletos ou desatualizados</li>
                        <li>Solicitar a exclusão de dados desnecessários</li>
                        <li>Revogar o consentimento a qualquer momento</li>
                        <li>Solicitar a portabilidade dos dados</li>
                    </ul>

                    <h2>6. Retenção de Dados</h2>
                    <p>
                        Mantemos seus dados pessoais pelo tempo necessário para cumprir as finalidades 
                        descritas nesta política ou conforme exigido por lei. Dados de compras são mantidos 
                        por no mínimo <strong>5 anos</strong> para fins fiscais.
                    </p>

                    <h2>7. Alterações na Política</h2>
                    <p>
                        Esta política pode ser atualizada periodicamente. Notificaremos você sobre 
                        mudanças significativas por email ou aviso no site.
                    </p>

                    <div className='info-contato'>
                        <h3>Dúvidas sobre privacidade?</h3>
                        <p>
                            Email: <a href="mailto:fracarostore@gmail.com">fracarostore@gmail.com</a><br />
                            WhatsApp: <a href="https://wa.me/5511997636154" target="_blank" rel="noopener noreferrer">(11) 99763-6154</a>
                        </p>
                    </div>

                    <p className='ultima-atualizacao'>Última atualização: Janeiro de 2026</p>
                </div>
            </main>
            <Rodape />
        </section>
    );
}
